import React from 'react';
import { EMPTY } from './roles';

/*::
type Props = {
  children?: Array<React.ReactChild>,
}
*/

const EmptyScreen = ({ children } /*: Props */) => {
  return <div className="ContentGroupEmptyScreen">{children}</div>;
};

EmptyScreen.role = EMPTY;

export default EmptyScreen;
